// extracted by css-extract-rspack-plugin
export default {"root":"If5lvm","title":"lHG3u_","subtitle":"x4i_ys"};